import vue from "vue";

export default {
    SET_NOTIFICATION: (state, notification) => {
        state.notification = notification;
    },
}
